import { render, staticRenderFns } from "./BadgeDisplay.vue?vue&type=template&id=02d4369e&"
import script from "./BadgeDisplay.vue?vue&type=script&lang=js&"
export * from "./BadgeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports